import { Helmet } from "react-helmet";
import Canonical from "../../../../components/common/layout/Canonical";
import { useTranslation } from "react-i18next";
import CorporateBanner from "../../../../components/common/form/CorporateBanner";
import { useEffect, useState } from "react";
// import Lightbox from "react-awesome-lightbox";
import Lightbox from 'react-image-lightbox';
import { url } from "../../../../shared/utils/url";
import { useSitemap } from "../../../../shared/hooks/use-sitemap";

const IllustrativeDesigns = () => {
    const [selectIdx, setSelectIdx] = useState<any>(null);
    const [idx, setIdx] = useState<any>(0);
    const { t } = useTranslation('common');
    useSitemap();
    const data: any[] = [
        {
            name: t("corporate.content_pages.illustrative_designs.data.tunnels"), img: `${url?.bucketUrl}/media/images/5.original.png`, imgs: [
                { url: `${url?.bucketUrl}/media/images/5.original.png`, title: t("corporate.content_pages.illustrative_designs.data.tunnels") },
                { url: `${url?.bucketUrl}/media/images/tunnel-1.original.png`, title: t("corporate.content_pages.illustrative_designs.data.tunnels") }
            ]
        },
        {
            name: t("corporate.content_pages.illustrative_designs.data.station"), img: `${url?.bucketUrl}/media/images/station-1.original.png`, imgs: [
                { url: `${url?.bucketUrl}/media/images/station-1.original.png`, title: t("corporate.content_pages.illustrative_designs.data.station") },
                { url: `${url?.bucketUrl}/media/images/station-4.original.png`, title: t("corporate.content_pages.illustrative_designs.data.station") },
                { url: `${url?.bucketUrl}/media/images/station-3.original.png`, title: t("corporate.content_pages.illustrative_designs.data.station") },
                { url: `${url?.bucketUrl}/media/images/station-2.original.png`, title: t("corporate.content_pages.illustrative_designs.data.station") }
            ]
        }
    ]

    useEffect(() => {
        if ((!!selectIdx || selectIdx === 0)) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
    }, [selectIdx]);

    return (
        <>
            <Canonical />
            <Helmet>
                <title>{t("seo_friendly.illustrative_designs.title")}</title>
                <meta name="description" content={t("seo_friendly.illustrative_designs.desc")} />
            </Helmet>

            <div className='bg-white dark:bg-bgDarkDull'>
                <CorporateBanner title={t("corporate.content_pages.illustrative_designs.title")} root1={t("corporate.content_pages.photo_gallery.home")} root2={t("corporate.content_pages.illustrative_designs.subtitle")} root3={t("corporate.content_pages.illustrative_designs.title")} />
                <div id="home" className="w-full container pt-[30px] xsm:pt-[40px] xlx:pt-[60px] pb-[60px] xsm:pb-[70px] lg:pb-[90px] xlx:pb-[110px] mms:!px-[30px]">
                    <div className="w-full grid grid-cols-1 xlsm:grid-cols-2 msm:grid-cols-3 gap-y-[15px] gap-x-[20px] xlx:gap-[30px]">
                        {Array?.isArray(data) && data?.map((item: any, index: number) => (
                            <button className="w-full flex flex-col border border-[#FFDCDC] dark:border-[#FFDCDC5e] hover:border-primary focus:border-primary dark:hover:border-primary dark:focus:border-primary p-[15px] focus:shadow-[0px_6px_14px_-6px_rgba(24,39,75,0.12),0px_10px_32px_-4px_rgba(24,39,75,0.10)] hover:shadow-[0px_6px_14px_-6px_rgba(24,39,75,0.12),0px_10px_32px_-4px_rgba(24,39,75,0.10)]" key={index} onClick={() => setSelectIdx(index)}>
                                <img src={item?.img} alt={item?.name} className="w-full h-[225px]" />

                                <h5 className="line-clamp-2 text-blackDull dark:text-textBlackDull font-bold text-left pt-[15px]">{item?.name}</h5>
                            </button>
                        ))}

                        {(!!selectIdx || selectIdx === 0) &&
                            // <Lightbox
                            //     onClose={() => setSelectIdx(null)}
                            //     images={data?.[selectIdx]?.imgs}
                            // />
                            <Lightbox
                                imageTitle={data?.[selectIdx]?.imgs?.[idx]?.title}
                                mainSrc={data?.[selectIdx]?.imgs?.[idx]?.url}
                                nextSrc={data?.[selectIdx]?.imgs?.[(idx + 1) % data?.[selectIdx]?.imgs.length]?.url}
                                prevSrc={data?.[selectIdx]?.imgs?.[(idx + data?.[selectIdx]?.imgs?.length - 1) % data?.[selectIdx]?.imgs?.length]?.url}
                                onCloseRequest={() => setSelectIdx(null)}
                                onMovePrevRequest={() => setIdx((idx + data?.[selectIdx]?.imgs.length - 1) % data?.[selectIdx]?.imgs?.length)}
                                onMoveNextRequest={() => setIdx((idx + 1) % data?.[selectIdx]?.imgs?.length)}
                            />
                        }
                    </div>
                </div>
            </div>
        </>
    );
};

export default IllustrativeDesigns;